import { useCallback, useEffect } from "react";

export function useClickOutside(
  refs: readonly React.RefObject<HTMLElement | null>[],
  callback: () => void,
  conditional = true,
): void {
  const handleClickOutside = useCallback(
    (e: MouseEvent | TouchEvent) => {
      const elements = refs.flatMap((ref) => (ref.current ? [ref.current] : []));

      if (elements.length === 0 || elements.some((element) => element.contains(e.target as Node))) {
        return;
      }

      callback();
    },
    [callback, refs],
  );

  useEffect(() => {
    if (conditional) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [handleClickOutside, conditional]);
}
